<template>
    <v-container class="container">
        <v-expansion-panels
            v-model="panel"
            class="expansion-panel"
        >
            <v-expansion-panel>
                <v-expansion-panel-header class="card-title mt-1">
                    <div>
                        <span class="mx-2 stylish-title">Στατιστικά</span>
                        <v-btn
                            icon
                            large
                            elevation="3"
                            class="mx-1 always-elevated-btn"
                            @click.stop="togglePanel()"
                        >
                            <v-icon class="filter-icon" medium :color="theming.cardsAndTablesText || 'black'">
                                mdi-filter-variant
                            </v-icon>
                        </v-btn>
                    </div>
                </v-expansion-panel-header>
                <v-divider/>
                <v-expansion-panel-content>
                    <div class="filters">
                        <!-- <v-select
                            v-model="filter.clientId"
                            :items="clients"
                            item-value="id"
                            item-text="name"
                            label="Πάροχος"
                            clearable
                            outlined
                            class="filter-field client"
                            @change="onClientSelect"
                        ></v-select> -->
                        <v-select
                            v-model="filter.type"
                            :items="this.types"
                            label="Τύπος"
                            outlined
                            clearable
                            class="filter-field"
                            @change="onTypeSelect"
                        >
                            <template v-slot:selection="data" >
                                {{ typeNames[data.item] }}
                            </template>
                            <template v-slot:item="data" >
                                {{ typeNames[data.item] }}
                            </template>
                        </v-select>
                        <v-select
                            v-model="filter.contractorId"
                            :items="contractors"
                            item-value="id"
                            item-text="name"
                            label="Ανατεθειμένος Εργολάβος"
                            outlined
                            class="filter-field client"
                            @change="onContractorSelect"
                        ></v-select>
                        <v-menu
                            v-model="menu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                            class="filter-field"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="filterDateText"
                                    class="filter-field calendar"
                                    label="Ανατέθηκε σε Εργολάβο"
                                    readonly
                                    hide-details
                                    clearable
                                    @click:clear="filterDateRange = []"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <template v-slot:prepend-inner>
                                        <v-icon :color="theming.cardsAndTablesText || 'black'">mdi-calendar</v-icon>
                                    </template>
                                </v-text-field>
                            </template>
                            <v-date-picker
                                v-model="filterDateRange"
                                range
                                color="#0047AB"
                                locale="el"
                                @change="filterDateSelected"
                                @input="() => { if (filterDateRange.length === 2) { menu = false }}"
                            ></v-date-picker>
                        </v-menu>
                        <v-menu
                            v-model="menu2"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                            class="filter-field"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="filterDateTextCreated"
                                    class="filter-field calendar"
                                    label="Δημιουργήθηκε"
                                    readonly
                                    hide-details
                                    clearable
                                    @click:clear="filterDateRangeCreated = []"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <template v-slot:prepend-inner>
                                        <v-icon :color="theming.cardsAndTablesText || 'black'">mdi-calendar</v-icon>
                                    </template>
                                </v-text-field>
                            </template>
                            <v-date-picker
                                v-model="filterDateRangeCreated"
                                range
                                color="#0047AB"
                                locale="el"
                                @change="filterCreatedDateSelected"
                                @input="() => { if (filterDateRangeCreated.length === 2) { menu = false }}"
                            ></v-date-picker>
                        </v-menu>
                    </div>
                    <!-- <div class="search-button-wrapper">
                        <v-btn class="mx-2 white--text" medium color="black" @click="getCounts">
                            <v-icon medium class="bulding-id-icon">mdi-filter</v-icon> Αναζητηση
                        </v-btn>
                    </div> -->
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
        <div
            v-for="contractorId of this.assignmentsCountMap.keys()"
            :key="contractorId"
        >
            <div v-if="(filter.contractorId === contractorId || filter.contractorId === -1) && contractorId !== -1" class="contractor-wrapper">
                <h3>{{ contractorMap.get(contractorId) }} </h3>
                <div class="cards">
                    <v-card
                        v-for="status of statusesForContractor(contractorId)"
                        :key="status.name"
                        class="mx-auto mb-3 card"
                        :color="status.color"
                        max-width="344"
                        min-width="344"
                        outlined
                        elevation="6"
                    >
                        <v-list-item  three-line>
                            <v-icon x-large class="pr-3" color="white">{{ status.icon }}</v-icon>
                            <v-list-item-content>
                                <v-list-item-title class="text-h5 mb-1 content">
                                    <span class="card-text">{{ status.name }}</span>
                                    <span class="card-value">{{ assignmentsCountMap.get(contractorId).get(status.value) }}</span>
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-card>
                </div>
            </div>
        </div>
    </v-container>
</template>
<script>
    import stats from '@/services/stats'
    import client from '@/services/client'
    import momentTimezone from 'moment-timezone'
    const COMPANY_NAME = process.env.VUE_APP_ENV_COMPANY_NAME
    export default {
        watch: {
            'filterDateRange'(newVal, oldVal) {
                if (newVal.length === 0) {
                    delete this.filter.assignedToContractorAtLte
                    delete this.filter.assignedToContractorAtGte
                    this.getCounts()
                }
            },
            'filterDateRangeCreated'(newVal, oldVal) {
                if (newVal.length === 0) {
                    delete this.filter.createdAtLte
                    delete this.filter.createdAtGte
                    this.getCounts()
                }
            }
        },
        computed: {
            theming() {
                return this.$store.getters.getTheming || {}
            },
            config() {
                return this.$store.getters.getConfig || {}
            },
            statuses() {
                return this.config?.assignmentStatuses || []
            },
            typeNames() {
                return Object.fromEntries(
                    this.config?.assignmentTypes?.map(item => [item.value, item.name])
                )
            }
        },
        data() {
            return {
                assignmentsCountMap: new Map(),
                panel: undefined,
                filter: {
                    contractorId: null
                },
                clients: [],
                contractors: [{ id: -1, name: 'ALL' }],
                contractorMap: new Map(),
                types: [],
                menu: null,
                filterDateRange: [],
                filterDateText: null,
                menu2: null,
                filterDateRangeCreated: [],
                filterDateTextCreated: null,
                ownerContractorId: null
            }
        },
        created() {
            this.getAllClients()
        },
        methods: {
            statusesForContractor(contractorId) {
                if (this.ownerContractorId === contractorId) {
                    return this.config?.assignmentStatuses?.filter(status => status.value !== 'ASSIGNED_TO') || []
                } else {
                    return this.config?.assignmentStatuses?.filter(status => status.value !== 'ASSIGNED') || []
                }
            },
            getAllClients() {
                client.getAllClients().then(resp => {
                    this.clients = resp.data
                    const allContractors = this.clients.flatMap(client => client.contractors)
                    this.contractors = this.contractors.concat(allContractors.filter(contractor => contractor.assignee))
                    this.contractors.forEach(contractor => {
                        this.contractorMap.set(contractor.id, contractor.name)
                        if (contractor.name.toUpperCase() === COMPANY_NAME.toUpperCase()) {
                            this.filter.contractorId = contractor.id
                            this.ownerContractorId = contractor.id
                        }
                    })
                    this.types = this.clients.flatMap(client => client.assignmentTypes)
                    this.getCounts()
                })
            },
            filterDateSelected(dateRange) {
                this.filterDateText = dateRange[0] + ' ~ ' + dateRange[1]
                this.filter.assignedToContractorAtGte = momentTimezone(dateRange[0] + ' 00:00:00').tz('Europe/Athens').utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]').toString()
                this.filter.assignedToContractorAtLte = momentTimezone(dateRange[1] + ' 23:59:59').tz('Europe/Athens').utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]').toString()
                this.getCounts()
            },
            filterCreatedDateSelected(dateRange) {
                this.filterDateTextCreated = dateRange[0] + ' ~ ' + dateRange[1]
                this.filter.createdAtGte = momentTimezone(dateRange[0] + ' 00:00:00').tz('Europe/Athens').utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]').toString()
                this.filter.createdAtLte = momentTimezone(dateRange[1] + ' 23:59:59').tz('Europe/Athens').utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]').toString()
                this.getCounts()
            },
            togglePanel() {
                const curr = this.panel
                this.panel = curr === undefined ? 0 : undefined
            },
            // onClientSelect(clientId) {
            //     const selectedClient = this.clients.find(client => client.id === clientId)
            //     if (selectedClient) {
            //         this.contractors = selectedClient.contractors
            //     }
            // },
            onContractorSelect(contractorId) {
                if (contractorId === -1) {
                    return
                }
                this.filter.contractorId = contractorId
                this.getCounts()
            },
            onTypeSelect(type) {
                this.filter.type = type
                this.getCounts()
            },
            getCounts() {
                this.assignmentsCountMap = new Map()
                this.contractors.forEach(contractor => {
                    const statusMap = new Map()
                    this.statuses.forEach(status => {
                        statusMap.set(status.value, 0)
                    })
                    this.assignmentsCountMap.set(contractor.id, statusMap)
                })
                stats.getAssignmentStatusCount(this.filter).then(resp => {
                    resp.data.forEach(element => {
                        let contractorMapData = this.assignmentsCountMap.get(element.contractorId)
                        contractorMapData.set(element.status, element.count)
                        this.assignmentsCountMap.set(element.contractorId, contractorMapData)
                    })
                    this.assignmentsCountMap = new Map(this.assignmentsCountMap)
                })
            }
        }
    }
</script>
<style scoped>
.filter-icon:hover {
    color: #febf15 !important;
}
.contractor-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 2rem;
}
.container {
    max-width: 90%;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.v-expansion-panel {
    color: var(--cards-and-tables-text-color) !important;
    background: var(--cards-and-tables-color) !important;
}

.filters {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
}

.filter-field {
    padding: 0.8rem;
    max-width: 300px;
}

.search-button-wrapper {
    display: flex;
    justify-content: center;
}
.card-title {
    font-weight: 500;
    font-size: 1.4rem;
}
.cards {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    width: 70%;
    margin-top: 1%;
}

.card-text {
    color: white;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.content {
    display: flex;
    flex-direction: column;
}
.card-value {
    color: white;
    font-size: 2rem;
    font-weight: 1000;
}
.header {
    font-weight: 600;
}

.client-name {
    font-weight: 400;
}

.v-list-item--three-line .v-list-item__content {
    align-self: center !important;
}

.client-card-value {
    font-weight: 800;
    font-size: 1rem;
}
.expansion-panel {
    max-width: 90%;
    margin: 0 auto;
}

.v-expansion-panel {
    color: var(--cards-and-tables-text-color) !important;
    background: var(--cards-and-tables-color) !important;
}

@media only screen and (max-width: 700px) {
    .container {
        max-width: 100% !important;
    }
    .cards {
        width: 100%;
    }
    .expansion-panel {
        max-width: 100%;
    }
}
</style>
